<template>
    <div class="account-box">
        <div class="title df aic jcsb">
            <span class="text fs-22 fw-b">{{ $t('基本信息') }}</span>
            <div>
                <el-button class="btn1">
                    {{ userInfo.subscribe == 10 ? $t('EDM已订阅') : (userInfo.subscribe == 20 ? $t('EDM已退订') : '') }}
                </el-button>
                <el-button class="btn2" @click="handlecancel_account">{{ $t('注销账号') }}</el-button>
            </div>
        </div>

        <!-- 用element写一个表单 包含字段 头像,昵称,姓名,电话,邮箱, -->
        <el-form :model="userInfo" :rules="rules" ref="userInfo" :label-width="180+'px'" class="demo-ruleForm pt-28">
            <el-form-item :label="$t('头像')" prop="avatar">
                <div class="avatar-box" style="width: 54px;height: 54px;">
                    <Uploadcropper v-model="userInfo.user_avatar"
                        :fileType="['JPG', 'JPEG', 'PNG', 'png', 'jpeg', 'jpg']" name="avatar" :fileLimit="1"
                        :fileSize="3" upType="IMGARR" :isUseOss="true" />
                </div>
            </el-form-item>

            <el-form-item :label="$t('昵称')" prop="user_nick_name">
                <el-input v-model="userInfo.user_nick_name" :placeholder="$t('请输入昵称')"></el-input>
            </el-form-item>

            <el-form-item :label="$t('姓名')" prop="user_name">
                <el-input v-model="userInfo.user_name" :placeholder="$t('请输入姓名')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('电话')" prop="user_contact_mobile" name="user_contact_mobile">


                <div class="df aic">
                    <template>
                        <div v-show="!isEditmobile" @click="handleShowmobile" class="pl-15" style="width: 100%;;max-width: 368px;border-radius: 4px;height: 40px;border: 1px solid #DCDFE6;">
                            <template v-if="userInfo.user_contact_mobile">
                                {{ $validTelHide(userInfo.user_contact_mobile) }}
                            </template>
                            <template v-else>
                                <span class="c-9">{{ $t('请输入电话号码')  }}</span>
                            </template>
                        </div>
                        <div v-show="isEditmobile"  style="width: 100%;;max-width: 368px;">
                            <el-input ref="mobile_ref" v-model="userInfo.user_contact_mobile" @blur="handleHidemobile" :placeholder="$t('请输入电话')"></el-input>
                        </div>
                    </template>
                    <!-- 加一个 单选 公开和加密 -->
                    <el-radio-group v-model="userInfo.user_mobile_show" class="ml-24 fn">
                        <el-radio :label="10">{{ $t('公开') }}</el-radio>
                        <el-radio :label="20">{{ $t('加密') }}</el-radio>
                    </el-radio-group>


                </div>
            </el-form-item>
            <el-form-item :label="$t('邮箱')" prop="user_contact_email" name="user_contact_email">
                <div class="df aic">

                    <template>
                        <div v-show="!isEditemail" @click="handleShowemail" class="pl-15" style="width: 100%;;max-width: 368px;border-radius: 4px;height: 40px;border: 1px solid #DCDFE6;">
                            {{ $validEmailHide(userInfo.user_contact_email) }}
                        </div>
                        <div v-show="isEditemail"  style="width: 100%;;max-width: 368px;">
                            <el-input ref="email_ref" v-model="userInfo.user_contact_email" @blur="handleHideemail" :placeholder="$t('请输入邮箱')"></el-input>
                        </div>
                    </template>


                    <!-- <el-input v-model="userInfo.user_contact_email" :placeholder="$t('请输入邮箱')"></el-input> -->
                    <el-radio-group v-model="userInfo.user_email_show" class="ml-24 fn">
                        <el-radio :label="10">{{ $t('公开') }}</el-radio>
                        <el-radio :label="20">{{ $t('加密') }}</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>

            <el-form-item :label="$t('EDM订阅')" prop="is_unsubscribe">
                <!-- 单选 订阅和退订 -->
                <el-radio-group v-model="userInfo.is_unsubscribe">
                    <el-radio :label="10">{{ $t('订阅') }}</el-radio>
                    <el-radio :label="20">{{ $t('退订') }}</el-radio>
                </el-radio-group>
            </el-form-item>

            <!-- 洲&国家/区域 -->
            <el-form-item :label="$t('洲&国家/区域')" prop="register_district" :class="{'tow-line':currentLanguage=='en'}" name="register_district">
                <el-select v-model="userInfo.register_district" :placeholder="$t('请选择洲')" @change="handleChangedistrict()">
                    <el-option v-for="item in allData.region_list" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>

                <el-select v-model="userInfo.register_country" :placeholder="$t('请选择国家/区域')" class="ml-24"
                    @change="handleChangecountry()">
                    <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- 省/州&城市 -->
            <el-form-item :label="$t('省/州&城市')" prop="province">
                <el-select v-model="userInfo.register_province" :placeholder="$t('请选择省/州')" @change="handleChangeprovince()">
                    <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>

                <el-select v-model="userInfo.register_city" :placeholder="$t('请选择城市')" class="ml-24"
                    @change="handleChangecity()">
                    <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- 行业 下拉单选 -->
            <el-form-item :label="$t('行业')" prop="user_industry" name="user_industry">
                <el-select v-model="userInfo.user_industry" :placeholder="$t('请选择行业')">
                    <el-option v-for="item in allData.user_industry_options" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- 公司名称 -->
            <el-form-item :label="$t('公司名称')" prop="user_company" name="user_company">
                <el-input v-model="userInfo.user_company" :placeholder="$t('请输入公司名称')"></el-input>
            </el-form-item>

            <!-- 职位 单选 -->

            <el-form-item :label="$t('职位')" prop="user_job" name="user_job">
                <el-select v-model="userInfo.user_job" :placeholder="$t('请选择职位')">
                    <el-option v-for="item in allData.user_job_options" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <!--  擅长领域  多选-->
            <el-form-item :label="$t('擅长领域')" prop="user_excel_arr" name="user_excel_arr">
                <el-select v-model="userInfo.user_excel_arr" multiple :placeholder="$t('请选择擅长领域')">
                    <el-option v-for="item in allData.user_excel_options" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- 角色 多选 -->
            <el-form-item :label="$t('角色')" prop="user_role_arr" name="user_role_arr">
                <el-select v-model="userInfo.user_role_arr" multiple :placeholder="$t('请选择角色')">
                    <el-option v-for="item in allData.user_role_options" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- 个性签名 多行文本域-->
            <el-form-item :label="$t('个性签名')" prop="user_sign">
                <el-input v-model="userInfo.user_sign" type="textarea" :placeholder="$t('请输入')" :rows="3"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm">{{ $t('保存') }}</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>

import { getUserInfo, userEdit, cancel_account } from "@api/usercenter";
import { getactivityGetArea } from "@api/active";
import Uploadcropper from "@comp/UploadCropper/avatar.vue";
import {applySubmit} from "@api/expert";
export default {
    components: { Uploadcropper },
    data() {
        return {
            userInfo: {
                // 昵称
                user_nick_name: '',
                // 姓名
                user_name: '',
                // 电话
                user_contact_mobile: '',
                // 电话是否公开
                user_mobile_show: '',
                // 邮箱
                user_contact_email: '',
                user_contact_email_hide: '',
                // 邮箱是否公开
                user_email_show: '',
                // EDM订阅
                is_unsubscribe: '',
                // 洲&国家/区域
                register_district: '',
                // 国家/区域
                register_country: '',
                // 省/州
                register_province: '',
                // 城市
                register_city: '',
                // 行业
                user_industry: '',
                // 公司名称
                user_company: '',
                // 职位
                user_job: '',
                // 擅长领域
                user_excel_arr: [],
                // 角色
                user_role_arr: [],
                // 个性签名
                user_sign: '',
                // 头像
                user_avatar: '',
            },


            // 电话  邮箱  编辑状态
            isEditmobile: true,
            isEditemail: true,

            // 电话邮箱是否加密
            isEncryptemail: 10,
            // 电话邮箱是否加密
            isEncryptmobile: 10,


            newuserInfo: {
                // 电话
                user_contact_mobile: '',
                // 邮箱
                user_contact_email: '',
            },

            rules: {
                // 昵称
                user_nick_name: [
                    {
                        required: true,
                        message: this.$t("请输入昵称"),
                        trigger: ["blur", "change"],
                    },  
                ],
                // 电话
                    user_contact_mobile: [
                        {
                            required: true,
                            message: this.$t("请输入电话"),
                            trigger: ["blur", "change"], 
                        }
                    ],

                    // 邮箱
                    user_contact_email: [
                        {
                            required: true,
                            message: this.$t("请输入邮箱"),
                            trigger: ["blur", "change"],
                        }
                    ],

                    //EDM订阅
                    is_unsubscribe: [
                        {
                            required: true,
                            message: this.$t("请选择EDM订阅"),
                            trigger: ["blur", "change"],
                        } 
                    ],

                    //洲&国家/区域
                    register_district: [
                        {
                            required: true,
                            message: this.$t("请选择洲"),
                            trigger: ["blur", "change"],
                        }
                    ],

                    //省/州&城市
                    register_country: [
                        {
                            required: true,
                            message: this.$t("请选择国家/区域"),
                            trigger: ["blur", "change"],
                        }  
                    ],

                    //行业
                    user_industry: [
                        {
                            required: true,
                            message: this.$t("请选择行业"),
                            trigger: ["blur", "change"],
                        }
                     ],
                    //公司名称
                    user_company: [
                        {
                            required: true,
                            message: this.$t("请输入公司名称"),
                            trigger: ["blur", "change"],
                        }
                     ],
                    //职位
                    user_job: [
                        {
                            required: true,
                            message: this.$t("请选择职位"),
                            trigger: ["blur", "change"],
                        }
                     ],

                     //角色
                     user_role_arr: [
                        {
                            required: true,
                            message: this.$t("请选择角色"),
                            trigger: ["blur", "change"],
                        } 
                     ],

                    //擅长领域
                    user_excel_arr: [
                        {
                            required: true,
                            message: this.$t("请选择擅长领域"),
                            trigger: ["blur", "change"],
                        }
                     ],

                    
                
            },
            allData: {},  //个人信息所有数据
            countryList: [],  //国家列表
            provinceList: [],  //省份列表
            cityList: [],  //城市列表

            // 当前语言
            currentLanguage: localStorage.getItem('currentLanguage'),

        }
    },
    created() {
        this.getUserInfo();
    },

    methods: {

        // 
        handleHidemobile(e){
            if(this.isEncryptmobile==20){
                this.isEditmobile = false;
            }
        },

        handleShowmobile(e){
            // 让 ref= mobile_ref 的input 获得焦点
            this.isEditmobile = true;
            setTimeout(() => {
                this.$refs.mobile_ref.focus();
            }, 20);
        },
        handleHideemail(e){

            if(this.isEncryptemail==20){
                this.isEditemail = false;
            }

        },

        handleShowemail(e){
            // 让 ref= mobile_ref 的input 获得焦点
            this.isEditemail = true;
            setTimeout(() => {
                this.$refs.email_ref.focus();
            }, 20);
        },


        // 注销
        handlecancel_account() {
            this.$confirm(this.$t("社区账户注销后不可恢复。你的私有数据将被永久删除，建议做好备份。账户等级等将失效，无法继续享受相关权益。您确定要注销账号吗？"), this.$t('温馨提示'), {
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
                type: 'warning'
            }).then(() => {
                cancel_account().then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: res.msg
                        });

                        setTimeout(() => {
                            this.$bus.$emit('changeUserinfo', this.userInfo.user_avatar);
                            this.$router.push('/');
                        }, 1000);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('已取消')
                });
            });
        },

        // 获取用户信息
        getUserInfo() {

            this.isEditmobile=true;
            this.isEditemail=true;

            // 电话邮箱加密状态

                // 电话邮箱是否加密
                this.isEncryptemail=10;
                
            // 电话邮箱是否加密
            this.isEncryptmobile= 10;



            const loading = this.$loading({
                lock: true,
                text: this.$t('拼命加载中'),
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            getUserInfo().then(res => {

                loading.close();
                if (res.status == 200) {
                    if(res.data.data.able_to_raffle == 1){
                        const datas = {
                            tre_ep: res.data.data.tre_ep,
                        }

                        this.insertScript("/static/raffle/index.js", JSON.stringify(datas), function () {
                        })
                    }

                    this.userInfo = res.data.data;

                    // 订阅情况
                    this.userInfo.subscribe = this.userInfo.is_unsubscribe;
                    // 地区选择

                    this.userInfo.register_district = this.userInfo.register_district && this.userInfo.register_district !== '0' ? this.userInfo.register_district : null;
                    this.userInfo.register_country = this.userInfo.register_country && this.userInfo.register_country !== '0' ? this.userInfo.register_country : null;
                    this.userInfo.register_province = this.userInfo.register_province && this.userInfo.register_province !== '0' ? this.userInfo.register_province : null;
                    this.userInfo.register_city = this.userInfo.register_city && this.userInfo.register_city !== '0' ? this.userInfo.register_city : null;
                    
                    // 添加对user_industry的处理
                    this.userInfo.user_industry = this.userInfo.user_industry && this.userInfo.user_industry !== 0 && this.userInfo.user_industry !== '0' ? this.userInfo.user_industry : null;
                    
                    // 将逗号分割的字符串转换为数组,并转成数字
                    //this.userInfo.user_excel_arr = this.userInfo.user_excel_arr.map(item => parseInt(item));
                    this.userInfo.user_excel_arr = this.userInfo.user_excel_arr
                    .map(item => {
                        if (item === '') {
                        return [];
                        }
                        return isNaN(parseInt(item)) ? null : parseInt(item);
                    })
                    .filter(item => {
                        return !(Array.isArray(item) && item.length === 0);
                    });
                    //this.userInfo.user_role_arr = this.userInfo.user_role_arr.map(item => parseInt(item));
                    this.userInfo.user_role_arr = this.userInfo.user_role_arr
                    .map(item => {
                        if (item === '') {
                        return [];
                        }
                        return isNaN(parseInt(item)) ? null : parseInt(item);
                    })
                    .filter(item => {
                        return !(Array.isArray(item) && item.length === 0);
                    });

                    if (this.userInfo.user_mobile_show == 20) {
                        this.isEditmobile = false;
                        this.isEncryptmobile=20;
                        // this.userInfo.user_contact_mobile_hide = this.$validTelHide(this.userInfo.user_contact_mobile);
                    }
                    if (this.userInfo.user_email_show == 20) {
                        this.isEditemail = false;
                        this.isEncryptemail=20;
                        // this.userInfo.user_contact_email_hide = this.$validEmailHide(this.userInfo.user_contact_email);
                    }


                    this.userInfo.user_job = this.userInfo.user_job && !isNaN(parseInt(this.userInfo.user_job)) ? parseInt(this.userInfo.user_job) : null;
                    
                    this.allData = res.data;

                    let obj = {
                        act_region: this.userInfo.register_district,
                        act_country: this.userInfo.register_country,
                        act_province: this.userInfo.register_province,
                        act_city: this.userInfo.register_city,
                    }
                    this.getCountryList(obj);
                    
                }
            })

        },

        handleChangedistrict() {
            this.countryList = [];
            this.provinceList = [];
            this.cityList = [];

            this.userInfo.register_country = '';
            this.userInfo.register_province = '';
            this.userInfo.register_city = '';

            let obj = {
                act_region: this.userInfo.register_district,
                act_country: this.userInfo.register_country,
                act_province: this.userInfo.register_province,
                act_city: this.userInfo.register_city,
            }

            this.getCountryList(obj);


        },
        handleChangecountry() {
            this.provinceList = [];
            this.cityList = [];

            this.userInfo.register_province = '';
            this.userInfo.register_city = '';

            let obj = {
                act_region: this.userInfo.register_district,
                act_country: this.userInfo.register_country,
                act_province: this.userInfo.register_province,
                act_city: this.userInfo.register_city,
            }
            this.getCountryList(obj);

        },
        handleChangeprovince() {
            this.cityList = [];
            this.userInfo.register_city = '';
            let obj = {
                act_region: this.userInfo.register_district,
                act_country: this.userInfo.register_country,
                act_province: this.userInfo.register_province,
                act_city: this.userInfo.register_city,
            }
            this.getCountryList(obj);
        },
        handleChangecity() {

        },
        //    获取国家
        getCountryList(obj) {

            getactivityGetArea({ ...obj }).then(res => {
                if (res.status == 200) {
                    console.log(res.data)
                    this.countryList = res.data.country_list;
                    this.provinceList = res.data.province_list;
                    this.cityList = res.data.city_list;
                }
            })
        },


        // 保存提交
        submitForm() {
          this.$refs['userInfo'].validate(async (valid) => {
            if (valid) {
              // 删除前后的逗号
              this.userInfo.user_excel = this.userInfo.user_excel_arr.join(',');

              this.userInfo.user_role=this.userInfo.user_role_arr.join(',');
              let obj = {
                ...this.userInfo,
              }

              obj.user_excel_arr = obj.user_excel_arr.map(item => String(item));
              obj.user_role_arr = obj.user_role_arr.map(item => String(item));
              userEdit(obj).then(res => {
                if (res.status == 200) {
                  this.$bus.$emit('changeUserinfo', this.userInfo.user_avatar);
                  this.$message.success(res.msg);
                  this.getUserInfo();
                  // this.$router.go(-1);
                }
              })
            } else {
              const firstErrorField = this.$refs.userInfo.fields.find(field => field.validateState === 'error');
              const errorElement = document.getElementsByName(firstErrorField.prop)[0];
              if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }

          })


        },
        insertScript(path, data, callback) {
             var new_element = document.createElement("script");
             new_element.setAttribute("type", "text/javascript");
             new_element.setAttribute("src", path);
             new_element.setAttribute("data-param", data);
             new_element.onload = callback; // 加载完成后调用回调
             document.body.appendChild(new_element);
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep() {
    .tow-line{
        .el-form-item__label{
            line-height: 22px !important;
        }
    }
   
   
    .el-input--suffix .el-input__inner{
        // 单行溢出隐藏
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-input,
    .el-textarea {
        max-width: 368px;
    }

    .el-radio {
        margin-right: 16px;
    }

    .el-radio__label {
        font-size: 14px;
    }

    .el-select {}
}

.avatar-box {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    // overflow: hidden;
    position: relative;

    .iconfont {

        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #e8f3ff;
        border-radius: 100px 100px 100px 100px;
        border: 2px solid #ffffff;
        position: absolute;
        right: -6px;
        bottom: -8px;
        text-align: center;
        line-height: 24px;
        color: #1e5fdd;

    }
}

.title {

    .text {
        padding-left: 19px;
        line-height: 30px;
        position: relative;

        &::before {
            content: "";
            display: block;
            width: 4px;
            height: 20px;
            background: #1e5fdd;
            position: absolute;
            left: 0;
            top: 6px;
        }
    }

    .btn1 {
        height: 32px;
        line-height: 30px;
        padding: 0 16px;
        border: 1px solid #dd2c2c;
        border-radius: 60px;
        font-size: 14px;
        color: #dd2c2c;
    }

    .btn2 {
        height: 32px;
        line-height: 30px;
        padding: 0 16px;
        border: none;
        border-radius: 60px;
        font-size: 14px;
        color: #858e9d;
        background: #F1F1F1;

        &:hover {
            background-color: #F4F4F5;
        }
    }
}
</style>